// Funzioni pure di mapping per la vista upload, estratte da `main.ts` (Batch 1).
//
// Nessun side-effect, nessun accesso al DOM: input → output deterministico.
// Dipendono solo da tipi/`ApiError` di `./api`. Comportamento identico a prima.

import { ApiError, type PhotoSummary, type UploadResult } from "./api";

/** Costruisce un PhotoSummary dalla risposta dell'upload (per render ottimistico). */
export function uploadToSummary(r: UploadResult): PhotoSummary {
  return {
    id: r.id,
    latitude: r.latitude,
    longitude: r.longitude,
    marker_group_key: r.marker_group_key,
    description: r.description,
    taken_at: r.taken_at,
    mime_type: r.mime_type,
    is_private: r.is_private,
    categories: r.categories ?? [],
    place_label: r.place_label ?? null,
    tag_male: r.tag_male,
    tag_female: r.tag_female,
    created_at: r.created_at,
  };
}

/** Mappa un errore di upload in un messaggio utente (nessun dettaglio tecnico). */
export function uploadErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    switch (err.code) {
      case "file_too_large":
        return "File troppo grande.";
      case "storage_full":
        return "Spazio esaurito.";
      case "unsupported_media_type":
        return "Formato non supportato. Usa JPEG, PNG o WebP.";
      case "invalid_request":
        return "Dati non validi (controlla file e coordinate).";
      default:
        return err.status === 401 ? "Sessione scaduta. Rientra." : "Errore durante il caricamento.";
    }
  }
  return "Errore durante il caricamento.";
}
